import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UsuarioService } from '../../core/services/usuario.service';
import { RolService, MenuApi, RolApi } from '../../core/services/rol.service';
import { AlertService } from '../../core/services/alert.service';
import { UiLoadingComponent } from '../../shared/components/ui-loading.component';
import { UsuarioApi } from '../../core/models/api/usuario-api';

@Component({
    selector: 'app-admin-usuarios',
    standalone: true,
    imports: [CommonModule, FormsModule, UiLoadingComponent],
    template: `
    <div class="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 class="text-2xl font-black text-gray-800">Usuarios y roles</h2>
        <p class="text-sm text-gray-400 mt-1">Asigna roles, retira accesos o desactiva cuentas.</p>
      </div>
      <div *ngIf="tab() === 'usuarios'" class="flex flex-wrap items-end gap-3">
      <label class="block min-w-52">
        <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Buscar</span>
        <input [(ngModel)]="key" (ngModelChange)="buscar($event)" placeholder="Correo o nombre…" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
      </label>
      <label class="block min-w-44">
        <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Rol</span>
        <select [(ngModel)]="rolFiltro" (ngModelChange)="filtrarRol($event)" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm bg-white outline-none focus:ring-2 focus:ring-rose-200">
          <option value="">Todos</option>
          <option *ngFor="let r of roles()" [value]="r.codigo">{{ r.nombre }}</option>
        </select>
      </label>
      </div>
    </div>

    <div class="flex gap-2 mb-6">
      <button type="button" (click)="tab.set('usuarios')" class="px-5 py-2.5 rounded-2xl text-sm font-bold border cursor-pointer"
        [class.bg-rose-500]="tab() === 'usuarios'" [class.text-white]="tab() === 'usuarios'" [class.border-rose-500]="tab() === 'usuarios'"
        [class.text-rose-500]="tab() !== 'usuarios'" [class.border-rose-200]="tab() !== 'usuarios'">Usuarios</button>
      <button type="button" (click)="tab.set('roles')" class="px-5 py-2.5 rounded-2xl text-sm font-bold border cursor-pointer"
        [class.bg-rose-500]="tab() === 'roles'" [class.text-white]="tab() === 'roles'" [class.border-rose-500]="tab() === 'roles'"
        [class.text-rose-500]="tab() !== 'roles'" [class.border-rose-200]="tab() !== 'roles'">Roles y accesos</button>
    </div>

    <app-ui-loading *ngIf="tab() === 'usuarios' && loading()"></app-ui-loading>

    <div *ngIf="tab() === 'usuarios' && !loading()" class="bg-white rounded-[2rem] border border-rose-100 shadow-sm overflow-hidden">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left text-xs uppercase tracking-wide text-gray-400 border-b border-gray-100">
            <th class="px-5 py-3">Usuario</th>
            <th class="px-5 py-3">Roles</th>
            <th class="px-5 py-3">Estado</th>
            <th class="px-5 py-3">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of usuarios()" class="border-b border-gray-50 align-top">
            <td class="px-5 py-3">
              <p class="font-black text-gray-800">{{ u.nombreVisible }}</p>
              <p class="text-xs text-gray-400">{{ u.correo }}</p>
            </td>
            <td class="px-5 py-3">
              <div class="flex flex-wrap gap-1 mb-2">
                <span *ngFor="let r of u.roles" class="text-[10px] font-bold uppercase px-2 py-1 rounded-full bg-rose-50 text-rose-500 flex items-center gap-1">
                  {{ r }}
                  <button *ngIf="confirmarQuitarRol() !== u.uuid + ':' + r" type="button" (click)="confirmarQuitarRol.set(u.uuid + ':' + r)" title="Quitar rol" class="cursor-pointer font-black">×</button>
                  <ng-container *ngIf="confirmarQuitarRol() === u.uuid + ':' + r">
                    <button type="button" (click)="quitarRol(u, r)" class="cursor-pointer font-bold text-red-500">Quitar</button>
                    <button type="button" (click)="confirmarQuitarRol.set(null)" class="cursor-pointer text-gray-400">No</button>
                  </ng-container>
                </span>
                <span *ngIf="u.roles.length === 0" class="text-xs text-gray-300">Sin roles</span>
              </div>
              <div class="flex gap-1">
                <select [(ngModel)]="rolPick[u.uuid]" class="rounded-xl border border-gray-200 px-2 py-1.5 text-xs bg-white outline-none">
                  <option value="">+ Rol…</option>
                  <option *ngFor="let r of roles()" [value]="r.uuid">{{ r.nombre }}</option>
                </select>
                <button type="button" (click)="darRol(u)" [disabled]="!rolPick[u.uuid]" class="px-3 py-1.5 rounded-xl text-white text-xs font-bold disabled:opacity-40 cursor-pointer" style="background-color: var(--bg-main);">Dar</button>
              </div>
            </td>
            <td class="px-5 py-3">
              <span class="text-[10px] font-bold uppercase px-2 py-1 rounded-full" [class.bg-emerald-50]="u.isActive" [class.text-emerald-600]="u.isActive" [class.bg-gray-100]="!u.isActive" [class.text-gray-500]="!u.isActive">
                {{ u.isActive ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td class="px-5 py-3">
              <button type="button" (click)="toggle(u)" class="px-3 py-1.5 rounded-xl border border-gray-200 text-xs font-bold text-gray-600 cursor-pointer">
                {{ u.isActive ? 'Desactivar' : 'Activar' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="usuarios().length === 0" class="px-5 py-8 text-center text-sm text-gray-400">Sin resultados.</p>
      <div class="flex items-center justify-between px-5 py-3 border-t border-gray-100 text-sm">
        <button type="button" (click)="pagina(false)" [disabled]="page() <= 1" class="px-4 py-2 rounded-xl border border-gray-200 font-bold text-gray-600 disabled:opacity-40 cursor-pointer">Anterior</button>
        <span class="text-xs text-gray-400">Página {{ page() }} de {{ totalPages() }}</span>
        <button type="button" (click)="pagina(true)" [disabled]="page() >= totalPages()" class="px-4 py-2 rounded-xl border border-gray-200 font-bold text-gray-600 disabled:opacity-40 cursor-pointer">Siguiente</button>
      </div>
    </div>

    <div *ngIf="tab() === 'roles'" class="mb-4">
      <p class="text-sm text-gray-400">Crea roles y marca qué paneles puede abrir cada uno. Los roles del sistema no se tocan.</p>
    </div>
    <div *ngIf="tab() === 'roles'" class="bg-white rounded-[2rem] border border-rose-100 shadow-sm p-5 flex flex-col sm:flex-row gap-3 sm:items-end mb-4">
      <label class="block flex-1">
        <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Código</span>
        <input [(ngModel)]="nuevoCodigo" placeholder="Ej: REPARTIDOR" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        <span class="text-[11px] text-gray-400">Solo mayúsculas, sin espacios.</span>
      </label>
      <label class="block flex-1">
        <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Nombre</span>
        <input [(ngModel)]="nuevoNombre" placeholder="Ej: Repartidor" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
      </label>
      <button type="button" (click)="crearRol()" [disabled]="!nuevoCodigo().trim() || !nuevoNombre().trim()" class="px-5 py-2.5 rounded-2xl text-white text-sm font-bold disabled:opacity-40 cursor-pointer" style="background-color: var(--bg-main);">Crear rol</button>
    </div>
    <div *ngIf="tab() === 'roles'" class="flex flex-col gap-3">
      <div *ngFor="let r of roles()" class="bg-white rounded-[2rem] border border-rose-100 shadow-sm p-5 flex flex-col gap-3">
        <button type="button" (click)="alternarRol(r.uuid)" class="flex items-center justify-between gap-2 text-left cursor-pointer">
          <span class="font-black text-gray-800">{{ r.nombre }}
            <span class="ml-2 text-[10px] font-bold uppercase px-2 py-1 rounded-full bg-gray-100 text-gray-500">{{ r.codigo }}</span>
            <span *ngIf="r.sistema" class="ml-1 text-[10px] font-bold uppercase px-2 py-1 rounded-full bg-amber-50 text-amber-600">sistema</span>
          </span>
          <svg class="w-4 h-4 text-gray-400 transition-transform" [class.rotate-180]="rolAbierto() === r.uuid" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
        </button>
        <div *ngIf="rolAbierto() === r.uuid" class="flex flex-col gap-2 border-t border-gray-100 pt-3">
          <label *ngFor="let m of (rolMenus()[r.uuid] ?? [])" class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer">
            <input type="checkbox" [checked]="m.asignado" [disabled]="r.sistema" (change)="alternarMenu(r, m)" class="w-5 h-5 accent-rose-500 cursor-pointer disabled:opacity-40" />
            <span class="font-bold flex-1">{{ m.nombre }}</span>
          </label>
          <ng-container *ngIf="!r.sistema && confirmarEliminarRol() !== r.uuid">
            <button type="button" (click)="confirmarEliminarRol.set(r.uuid)" class="self-start mt-1 text-xs font-bold text-red-500 hover:underline cursor-pointer">Eliminar rol</button>
          </ng-container>
          <span *ngIf="!r.sistema && confirmarEliminarRol() === r.uuid" class="self-start mt-1 flex items-center gap-3 text-xs font-bold">
            <span class="text-red-500">¿Eliminar este rol?</span>
            <button type="button" (click)="eliminarRol(r)" class="text-red-500 hover:underline cursor-pointer">Sí, eliminar</button>
            <button type="button" (click)="confirmarEliminarRol.set(null)" class="text-gray-400 hover:underline cursor-pointer">Cancelar</button>
          </span>
          <p *ngIf="r.sistema" class="text-xs text-gray-400">Los roles del sistema siempre tienen todos los accesos.</p>
        </div>
      </div>
    </div>
    `
})
export class AdminUsuariosComponent implements OnInit {
    private usuariosService = inject(UsuarioService);
    private rolesService = inject(RolService);
    private alerts = inject(AlertService);

    tab = signal<'usuarios' | 'roles'>('usuarios');
    loading = signal(true);
    usuarios = signal<UsuarioApi[]>([]);
    roles = signal<RolApi[]>([]);
    rolPick: Record<string, string> = {};
    key = signal('');
    rolFiltro = signal('');
    page = signal(1);
    total = signal(0);
    pageSize = 9;
    private searchTimer: ReturnType<typeof setTimeout> | null = null;

    rolMenus = signal<Record<string, MenuApi[]>>({});
    rolAbierto = signal<string | null>(null);
    nuevoCodigo = signal('');
    nuevoNombre = signal('');

    ngOnInit(): void {
        this.rolesService.listRoles().subscribe({
            next: (rows) => this.roles.set(rows),
            error: () => undefined
        });
        this.cargar();
    }

    totalPages(): number {
        return Math.max(1, Math.ceil(this.total() / this.pageSize));
    }

    buscar(term: string) {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(() => {
            this.page.set(1);
            this.cargar();
        }, 400);
    }

    filtrarRol(codigo: string) {
        this.page.set(1);
        this.cargar();
    }

    pagina(next: boolean) {
        this.page.update((p) => next ? p + 1 : Math.max(1, p - 1));
        this.cargar();
    }

    darRol(u: UsuarioApi) {
        const rolUuid = this.rolPick[u.uuid];
        if (!rolUuid) {
            return;
        }
        this.usuariosService.assignRol(u.uuid, rolUuid).subscribe({
            next: (tx) => {
                this.alerts.ok(tx.message);
                this.rolPick[u.uuid] = '';
                this.cargar();
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo asignar el rol.')
        });
    }

    confirmarQuitarRol = signal<string | null>(null);
    confirmarEliminarRol = signal<string | null>(null);

    quitarRol(u: UsuarioApi, codigo: string) {
        this.confirmarQuitarRol.set(null);
        const rol = this.roles().find((r) => r.codigo === codigo);
        if (!rol) {
            this.alerts.error('Rol no encontrado en el catálogo.');
            return;
        }
        this.usuariosService.removeRol(u.uuid, rol.uuid).subscribe({
            next: (tx) => {
                this.alerts.ok(tx.message);
                this.cargar();
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo retirar el rol.')
        });
    }

    toggle(u: UsuarioApi) {
        this.usuariosService.toggleActivo(u.uuid).subscribe({
            next: (tx) => {
                this.alerts.ok(tx.message);
                this.cargar();
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo cambiar el estado.')
        });
    }

    alternarRol(uuid: string) {
        if (this.rolAbierto() === uuid) {
            this.rolAbierto.set(null);
            return;
        }
        this.rolAbierto.set(uuid);
        if (!this.rolMenus()[uuid]) {
            this.rolesService.rolMenus(uuid).subscribe({
                next: (menus) => this.rolMenus.update((m) => ({ ...m, [uuid]: menus })),
                error: (err) => this.alerts.error(err?.message || 'No se pudieron cargar los accesos.')
            });
        }
    }

    alternarMenu(r: RolApi, m: MenuApi) {
        const req$ = m.asignado
            ? this.rolesService.removeMenu(r.uuid, m.uuid)
            : this.rolesService.assignMenu(r.uuid, m.uuid);
        req$.subscribe({
            next: (tx) => {
                this.alerts.ok(tx.message);
                this.rolesService.rolMenus(r.uuid).subscribe({
                    next: (menus) => this.rolMenus.update((x) => ({ ...x, [r.uuid]: menus })),
                    error: () => undefined
                });
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo actualizar el acceso.')
        });
    }

    crearRol() {
        if (!this.nuevoCodigo().trim() || !this.nuevoNombre().trim()) {
            return;
        }
        this.rolesService.createRol({ codigo: this.nuevoCodigo().trim(), nombre: this.nuevoNombre().trim() }).subscribe({
            next: (tx) => {
                this.alerts.ok(tx.message);
                this.nuevoCodigo.set('');
                this.nuevoNombre.set('');
                this.rolesService.listRoles().subscribe({
                    next: (rows) => this.roles.set(rows),
                    error: () => undefined
                });
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo crear el rol.')
        });
    }

    eliminarRol(r: RolApi) {
        this.confirmarEliminarRol.set(null);
        this.rolesService.deleteRol(r.uuid).subscribe({
            next: (tx) => {
                this.alerts.ok(tx.message);
                this.rolesService.listRoles().subscribe({
                    next: (rows) => this.roles.set(rows),
                    error: () => undefined
                });
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo eliminar el rol.')
        });
    }

    private cargar() {
        this.loading.set(true);
        this.usuariosService.listUsuarios(this.key(), this.rolFiltro() || undefined, this.page(), this.pageSize).subscribe({
            next: (res) => {
                this.usuarios.set(res.data);
                this.total.set(res.total);
                this.loading.set(false);
            },
            error: (err) => {
                this.loading.set(false);
                this.alerts.error(err?.message || 'No se pudieron cargar los usuarios.');
            }
        });
    }
}
